import { useRef, useState } from 'react'

import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { FormProdutos } from '../../components/Forms/FormProdutos'

import ProdutosService from '../../services/database/ProdutosService'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

export function NovoProduto() {
  const [isCreateProductLoading, setIsCreateProductLoading] = useState(false)

  const formProdutosRef = useRef(null)

  const navigate = useNavigate()

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setIsCreateProductLoading(true)

      const { product } = formProdutosRef?.current?.getProduct()

      if (
        product.DESCRICAO === '' ||
        product.ID_CATEGORIA === '' ||
        product.ID_SUBCATEGORIA === '' ||
        product.MARCA === '' ||
        product.PRECOCUSTO === '0' ||
        product.PRECOVENDA === '0'
      ) {
        return toast.error('Existem campos obrigatórios a serem preenchidos!')
      }

      const { CODPRODUTO } = await ProdutosService.create(product)

      toast.success('Produto cadastrado com sucesso!')

      navigate(`/produtos/${CODPRODUTO}`, { replace: true })
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível cadastrar o produto!')
    } finally {
      setIsCreateProductLoading(false)
    }
  }

  return (
    <FormProdutos
      ref={formProdutosRef}
      titlePage="Criar Produto"
      onSubmit={handleSubmit}
      isRequestLoading={isCreateProductLoading}
    />
  )
}
